import '../../extensions/array';
import "../../extensions/htmlelement";
import { Validators } from './validators';
import { Form } from '../../helpers/form';
export class Validation {
    constructor(form, rules) {
        this.errors = [];
        this.form = form;
        this.rules = rules;
        this.inlineRules();
        this.form.onsubmit = (e) => {
            if (!this.validate()) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                return false;
            }
            if (this.onSubmit && typeof this.onSubmit == "function") {
                e.preventDefault();
                e.stopPropagation();
                this.onSubmit.call(this, this.form);
            }
        };
    }
    inlineRules() {
        let elements = Form.inputs(this.form);
        elements.each((element) => {
            let rule = this.getInlineRules(element);
            if (rule != null) {
                this.rules.push(rule);
            }
        });
    }
    getInlineRules(element) {
        let html = element.outerHTML;
        let validators = [];
        const regex = /val-([\w\d]+)=["|']([^"|']*)["|']/gm;
        let match;
        while ((match = regex.exec(html)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (match.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            let validator = {
                function: match[1],
                args: match[2],
                message: this.getInlineRuleMessage(element, match[1])
            };
            validators.push(validator);
        }
        return validators.length == 0 ? null : {
            element: element.getAttribute("name"),
            validators: validators
        };
    }
    getInlineRuleMessage(element, rule) {
        let html = element.outerHTML;
        const regex = new RegExp("val-(" + rule + ")-([message|msg]+)=[\"|']([^\"\']*)[\"|']", "gm");
        let match = regex.exec(html);
        return match != null && match.length > 3 ? match[3] : "";
    }
    validate() {
        this.errors = [];
        this.rules.each((rule) => {
            let element = this.form.querySelector('[name="' + rule.element + '"]');
            let errors = [];
            rule.validators.each((validator) => {
                if (typeof Validators[validator.function] === "function") {
                    let valid;
                    if (validator.args)
                        valid = Validators[validator.function].call(this, element, validator.args);
                    else
                        valid = Validators[validator.function].call(this, element);
                    if (!valid) {
                        errors.push({ element: element, message: validator.message });
                    }
                }
                else {
                    let notFound = "validator: \"" + validator.function + "\" not found!";
                    errors.push({ element: element, message: notFound });
                }
            });
            if (errors.length == 0) {
                this.setElement(element, true);
            }
            else {
                this.errors = this.errors.concat(errors);
                this.setElement(element, false, errors[0].message);
            }
        });
        this.setSummary(this.errors);
        console.log("errors: ", this.errors);
        this.form.addClass("was-validated");
        this.form.onchange = (e) => {
            this.validate();
        };
        return this.errors.length == 0;
    }
    setElement(element, valid, message = "*") {
        if (!element)
            return;
        //Check if element has id, else set element id to element name
        if (!element.id)
            element.id = element.getAttribute("name");
        let labelId = element.id + "-invalid-feedback";
        let label = window.document.querySelector("#" + labelId);
        if (valid) {
            element.addClass("is-valid");
            element.removeClass("is-invalid");
            element.setCustomValidity("");
            if (label) {
                label.remove();
            }
        }
        else {
            element.addClass("is-invalid");
            element.removeClass("is-valid");
            element.setCustomValidity("sdfsf");
            if (!label) {
                label = window.document.createElement("label");
                label.setAttribute("for", element.id);
                label.setAttribute("id", labelId);
                label.setAttribute("class", "invalid-feedback");
                element.after(label);
            }
            label.innerHTML = message;
        }
    }
    setSummary(errors) {
        let summary = this.form.querySelector(".invalid-summary");
        if (!summary) {
            summary = window.document.createElement("div");
            summary.addClass("invalid-summary");
            this.form.appendChild(summary);
        }
        summary.empty();
        if (errors.length == 0) {
            summary.visible(false);
        }
        else {
            summary.visible(true);
            let ul = window.document.createElement("ul");
            errors.each(error => {
                let li = window.document.createElement("li");
                let label = window.document.createElement("label");
                label.setAttribute("for", error.element.id);
                label.setAttribute("class", "invalid-feedback");
                label.innerHTML = error.message;
                li.appendChild(label);
                ul.appendChild(li);
            });
            summary.appendChild(ul);
        }
    }
}
